import Vue from 'vue'
import Router from 'vue-router'
import { normalizeURL, decode } from 'ufo'
import { interopDefault } from './utils'
import scrollBehavior from './router.scrollBehavior.js'

const _7c14f56c = () => interopDefault(import('../pages/editing/index.vue' /* webpackChunkName: "pages/editing/index" */))
const _93cf9df6 = () => interopDefault(import('../pages/script.js' /* webpackChunkName: "pages/script" */))
const _402bc367 = () => interopDefault(import('../pages/view/index.vue' /* webpackChunkName: "pages/view/index" */))
const _6efa74ee = () => interopDefault(import('../pages/core/callback/index.vue' /* webpackChunkName: "pages/core/callback/index" */))
const _4a93814c = () => interopDefault(import('../pages/core/error/index.vue' /* webpackChunkName: "pages/core/error/index" */))
const _bd409d60 = () => interopDefault(import('../pages/core/my-account/index.vue' /* webpackChunkName: "pages/core/my-account/index" */))
const _05254216 = () => interopDefault(import('../pages/core/role-not-found/index.vue' /* webpackChunkName: "pages/core/role-not-found/index" */))
const _17d52318 = () => interopDefault(import('../pages/core/welcome/index.vue' /* webpackChunkName: "pages/core/welcome/index" */))
const _89a5f764 = () => interopDefault(import('../pages/editing/script.js' /* webpackChunkName: "pages/editing/script" */))
const _57429bf5 = () => interopDefault(import('../pages/gaia/achievements/index.vue' /* webpackChunkName: "pages/gaia/achievements/index" */))
const _75dd328f = () => interopDefault(import('../pages/gaia/calendar/index.vue' /* webpackChunkName: "pages/gaia/calendar/index" */))
const _094cd4f0 = () => interopDefault(import('../pages/gaia/dashboards/index.vue' /* webpackChunkName: "pages/gaia/dashboards/index" */))
const _d711bbfe = () => interopDefault(import('../pages/gaia/grade-template/index.vue' /* webpackChunkName: "pages/gaia/grade-template/index" */))
const _aec610a0 = () => interopDefault(import('../pages/gaia/lti-launch/index.vue' /* webpackChunkName: "pages/gaia/lti-launch/index" */))
const _8d2554b6 = () => interopDefault(import('../pages/gaia/lti-resolve/index.vue' /* webpackChunkName: "pages/gaia/lti-resolve/index" */))
const _f2dbe358 = () => interopDefault(import('../pages/gaia/lti-tools/index.vue' /* webpackChunkName: "pages/gaia/lti-tools/index" */))
const _996737ec = () => interopDefault(import('../pages/gaia/my-achievements/index.vue' /* webpackChunkName: "pages/gaia/my-achievements/index" */))
const _517448dc = () => interopDefault(import('../pages/gaia/new-calendar/index.vue' /* webpackChunkName: "pages/gaia/new-calendar/index" */))
const _eb3d3d22 = () => interopDefault(import('../pages/gaia/page-messages/index.vue' /* webpackChunkName: "pages/gaia/page-messages/index" */))
const _4e05c137 = () => interopDefault(import('../pages/gaia/question/index.vue' /* webpackChunkName: "pages/gaia/question/index" */))
const _4590ae9a = () => interopDefault(import('../pages/gaia/report-center/index.vue' /* webpackChunkName: "pages/gaia/report-center/index" */))
const _7f43d249 = () => interopDefault(import('../pages/view/script.js' /* webpackChunkName: "pages/view/script" */))
const _0eb69ec6 = () => interopDefault(import('../pages/core/auth/forgot-username/index.vue' /* webpackChunkName: "pages/core/auth/forgot-username/index" */))
const _60de6e8a = () => interopDefault(import('../pages/core/auth/signin/index.vue' /* webpackChunkName: "pages/core/auth/signin/index" */))
const _55adeeb1 = () => interopDefault(import('../pages/core/auth/signup/index.vue' /* webpackChunkName: "pages/core/auth/signup/index" */))
const _19ce4e3c = () => interopDefault(import('../pages/core/error/script.js' /* webpackChunkName: "pages/core/error/script" */))
const _3f107f9c = () => interopDefault(import('../pages/core/my-account/script.js' /* webpackChunkName: "pages/core/my-account/script" */))
const _3c856dd7 = () => interopDefault(import('../pages/core/role-not-found/script.js' /* webpackChunkName: "pages/core/role-not-found/script" */))
const _332d7d56 = () => interopDefault(import('../pages/core/welcome/script.js' /* webpackChunkName: "pages/core/welcome/script" */))
const _d34aaa52 = () => interopDefault(import('../pages/gaia/achievements/script.js' /* webpackChunkName: "pages/gaia/achievements/script" */))
const _6f057be4 = () => interopDefault(import('../pages/gaia/admin/batch-edit/index.vue' /* webpackChunkName: "pages/gaia/admin/batch-edit/index" */))
const _cee25f38 = () => interopDefault(import('../pages/gaia/admin/batch-edit-logs/index.vue' /* webpackChunkName: "pages/gaia/admin/batch-edit-logs/index" */))
const _079970ad = () => interopDefault(import('../pages/gaia/admin/categories/index.vue' /* webpackChunkName: "pages/gaia/admin/categories/index" */))
const _104a993e = () => interopDefault(import('../pages/gaia/admin/config-homepage/index.vue' /* webpackChunkName: "pages/gaia/admin/config-homepage/index" */))
const _bcaf9e30 = () => interopDefault(import('../pages/gaia/admin/content-management/index.vue' /* webpackChunkName: "pages/gaia/admin/content-management/index" */))
const _3cfae880 = () => interopDefault(import('../pages/gaia/admin/functions/index.vue' /* webpackChunkName: "pages/gaia/admin/functions/index" */))
const _294a031b = () => interopDefault(import('../pages/gaia/admin/lti-providers/index.vue' /* webpackChunkName: "pages/gaia/admin/lti-providers/index" */))
const _4a84b340 = () => interopDefault(import('../pages/gaia/admin/notices/index.vue' /* webpackChunkName: "pages/gaia/admin/notices/index" */))
const _e23cce92 = () => interopDefault(import('../pages/gaia/admin/periods/index.vue' /* webpackChunkName: "pages/gaia/admin/periods/index" */))
const _04b64e6a = () => interopDefault(import('../pages/gaia/admin/rubrics/index.vue' /* webpackChunkName: "pages/gaia/admin/rubrics/index" */))
const _23b24bac = () => interopDefault(import('../pages/gaia/admin/terms/index.vue' /* webpackChunkName: "pages/gaia/admin/terms/index" */))
const _3d00ba26 = () => interopDefault(import('../pages/gaia/admin/users/index.vue' /* webpackChunkName: "pages/gaia/admin/users/index" */))
const _96157d1e = () => interopDefault(import('../pages/gaia/calendar/script.js' /* webpackChunkName: "pages/gaia/calendar/script" */))
const _31355a80 = () => interopDefault(import('../pages/gaia/content/script.js' /* webpackChunkName: "pages/gaia/content/script" */))
const _4864e3d2 = () => interopDefault(import('../pages/gaia/dashboards/script.js' /* webpackChunkName: "pages/gaia/dashboards/script" */))
const _58e19e3a = () => interopDefault(import('../pages/gaia/grade-template/script.js' /* webpackChunkName: "pages/gaia/grade-template/script" */))
const _3095f2dc = () => interopDefault(import('../pages/gaia/lti-launch/script.js' /* webpackChunkName: "pages/gaia/lti-launch/script" */))
const _0ef536f2 = () => interopDefault(import('../pages/gaia/lti-resolve/script.js' /* webpackChunkName: "pages/gaia/lti-resolve/script" */))
const _74abc594 = () => interopDefault(import('../pages/gaia/lti-tools/script.js' /* webpackChunkName: "pages/gaia/lti-tools/script" */))
const _1b371a28 = () => interopDefault(import('../pages/gaia/my-achievements/script.js' /* webpackChunkName: "pages/gaia/my-achievements/script" */))
const _dee75084 = () => interopDefault(import('../pages/gaia/new-calendar/script.js' /* webpackChunkName: "pages/gaia/new-calendar/script" */))
const _6d0d1f5e = () => interopDefault(import('../pages/gaia/page-messages/script.js' /* webpackChunkName: "pages/gaia/page-messages/script" */))
const _225b6439 = () => interopDefault(import('../pages/gaia/plataforma-error/script.js' /* webpackChunkName: "pages/gaia/plataforma-error/script" */))
const _e5c45fce = () => interopDefault(import('../pages/gaia/question/script.js' /* webpackChunkName: "pages/gaia/question/script" */))
const _1c4fb795 = () => interopDefault(import('../pages/gaia/report-center/script.js' /* webpackChunkName: "pages/gaia/report-center/script" */))
const _375f0d9f = () => interopDefault(import('../pages/gaia/student/my-notices/index.vue' /* webpackChunkName: "pages/gaia/student/my-notices/index" */))
const _37bcbf7f = () => interopDefault(import('../pages/core/auth/forgot-username/script.js' /* webpackChunkName: "pages/core/auth/forgot-username/script" */))
const _13af2dfe = () => interopDefault(import('../pages/core/auth/password/change/index.vue' /* webpackChunkName: "pages/core/auth/password/change/index" */))
const _136ebeec = () => interopDefault(import('../pages/core/auth/password/expired/index.vue' /* webpackChunkName: "pages/core/auth/password/expired/index" */))
const _3eda4b76 = () => interopDefault(import('../pages/core/auth/password/new/index.vue' /* webpackChunkName: "pages/core/auth/password/new/index" */))
const _63fb84b4 = () => interopDefault(import('../pages/core/auth/password/reset/index.vue' /* webpackChunkName: "pages/core/auth/password/reset/index" */))
const _0ea8d79d = () => interopDefault(import('../pages/core/auth/signin/script.js' /* webpackChunkName: "pages/core/auth/signin/script" */))
const _d67404da = () => interopDefault(import('../pages/core/auth/signup/script.js' /* webpackChunkName: "pages/core/auth/signup/script" */))
const _a9109b8c = () => interopDefault(import('../pages/gaia/admin/academic/script.js' /* webpackChunkName: "pages/gaia/admin/academic/script" */))
const _50b24174 = () => interopDefault(import('../pages/gaia/admin/batch-edit-logs/script.js' /* webpackChunkName: "pages/gaia/admin/batch-edit-logs/script" */))
const _079550f0 = () => interopDefault(import('../pages/gaia/admin/batch-edit/script.js' /* webpackChunkName: "pages/gaia/admin/batch-edit/script" */))
const _46b17f8f = () => interopDefault(import('../pages/gaia/admin/categories/script.js' /* webpackChunkName: "pages/gaia/admin/categories/script" */))
const _4f62a820 = () => interopDefault(import('../pages/gaia/admin/config-homepage/script.js' /* webpackChunkName: "pages/gaia/admin/config-homepage/script" */))
const _3e7f806c = () => interopDefault(import('../pages/gaia/admin/content-management/script.js' /* webpackChunkName: "pages/gaia/admin/content-management/script" */))
const _209a9aa2 = () => interopDefault(import('../pages/gaia/admin/functions/script.js' /* webpackChunkName: "pages/gaia/admin/functions/script" */))
const _686211fd = () => interopDefault(import('../pages/gaia/admin/lti-providers/script.js' /* webpackChunkName: "pages/gaia/admin/lti-providers/script" */))
const _ecc67bbc = () => interopDefault(import('../pages/gaia/admin/notices/script.js' /* webpackChunkName: "pages/gaia/admin/notices/script" */))
const _640cb0ce = () => interopDefault(import('../pages/gaia/admin/periods/script.js' /* webpackChunkName: "pages/gaia/admin/periods/script" */))
const _3cbce7ad = () => interopDefault(import('../pages/gaia/admin/rubrics/script.js' /* webpackChunkName: "pages/gaia/admin/rubrics/script" */))
const _62ca5a8e = () => interopDefault(import('../pages/gaia/admin/terms/script.js' /* webpackChunkName: "pages/gaia/admin/terms/script" */))
const _2097b1cf = () => interopDefault(import('../pages/gaia/admin/users/script.js' /* webpackChunkName: "pages/gaia/admin/users/script" */))
const _ae3d74a0 = () => interopDefault(import('../pages/gaia/student/my-grades/script.js' /* webpackChunkName: "pages/gaia/student/my-grades/script" */))
const _76771c81 = () => interopDefault(import('../pages/gaia/student/my-notices/script.js' /* webpackChunkName: "pages/gaia/student/my-notices/script" */))
const _281e223c = () => interopDefault(import('../pages/gaia/teacher/grades/script.js' /* webpackChunkName: "pages/gaia/teacher/grades/script" */))
const _06a2ff4c = () => interopDefault(import('../pages/gaia/teacher/messages/script.js' /* webpackChunkName: "pages/gaia/teacher/messages/script" */))
const _354077e3 = () => interopDefault(import('../pages/core/auth/password/change/script.js' /* webpackChunkName: "pages/core/auth/password/change/script" */))
const _3560af6c = () => interopDefault(import('../pages/core/auth/password/expired/script.js' /* webpackChunkName: "pages/core/auth/password/expired/script" */))
const _b9d8d8d4 = () => interopDefault(import('../pages/core/auth/password/reset/script.js' /* webpackChunkName: "pages/core/auth/password/reset/script" */))
const _2b95f51a = () => interopDefault(import('../pages/core/auth/social/google/script.js' /* webpackChunkName: "pages/core/auth/social/google/script" */))
const _9cca86c2 = () => interopDefault(import('../pages/core/auth/social/linkedin/script.js' /* webpackChunkName: "pages/core/auth/social/linkedin/script" */))
const _77002223 = () => interopDefault(import('../pages/index.vue' /* webpackChunkName: "pages/index" */))
const _7392c4ea = () => interopDefault(import('../pages/gaia/admin/users/edit/_id.vue' /* webpackChunkName: "pages/gaia/admin/users/edit/_id" */))
const _7996c71f = () => interopDefault(import('../pages/gaia/admin/academic/_type.vue' /* webpackChunkName: "pages/gaia/admin/academic/_type" */))
const _78afc6ab = () => interopDefault(import('../pages/gaia/admin/functions/_id/index.vue' /* webpackChunkName: "pages/gaia/admin/functions/_id/index" */))
const _b1b0ef86 = () => interopDefault(import('../pages/gaia/student/my-enrollments/_type/index.vue' /* webpackChunkName: "pages/gaia/student/my-enrollments/_type/index" */))
const _1dff7271 = () => interopDefault(import('../pages/gaia/student/my-grades/_courseId.vue' /* webpackChunkName: "pages/gaia/student/my-grades/_courseId" */))
const _79b9ae06 = () => interopDefault(import('../pages/gaia/teacher/grades/_courseId.vue' /* webpackChunkName: "pages/gaia/teacher/grades/_courseId" */))
const _230e0552 = () => interopDefault(import('../pages/gaia/teacher/messages/_id.vue' /* webpackChunkName: "pages/gaia/teacher/messages/_id" */))
const _46f0c8f5 = () => interopDefault(import('../pages/gaia/teacher/my/_id/index.vue' /* webpackChunkName: "pages/gaia/teacher/my/_id/index" */))
const _907054e6 = () => interopDefault(import('../pages/gaia/admin/functions/_id/script.js' /* webpackChunkName: "pages/gaia/admin/functions/_id/script" */))
const _3380d1c2 = () => interopDefault(import('../pages/gaia/student/my-enrollments/_type/script.js' /* webpackChunkName: "pages/gaia/student/my-enrollments/_type/script" */))
const _f3ee5052 = () => interopDefault(import('../pages/gaia/teacher/my/_id/script.js' /* webpackChunkName: "pages/gaia/teacher/my/_id/script" */))
const _9b4f86b0 = () => interopDefault(import('../pages/gaia/student/my-enrollments/_type/_id/index.vue' /* webpackChunkName: "pages/gaia/student/my-enrollments/_type/_id/index" */))
const _1d1f68ec = () => interopDefault(import('../pages/gaia/student/my-enrollments/_type/_id/script.js' /* webpackChunkName: "pages/gaia/student/my-enrollments/_type/_id/script" */))
const _7b76a5c6 = () => interopDefault(import('../pages/gaia/content/_id.vue' /* webpackChunkName: "pages/gaia/content/_id" */))
const _2d5aeedc = () => interopDefault(import('../pages/gaia/course/_courseId/index.vue' /* webpackChunkName: "pages/gaia/course/_courseId/index" */))
const _0184c17f = () => interopDefault(import('../pages/gaia/plataforma-error/_id.vue' /* webpackChunkName: "pages/gaia/plataforma-error/_id" */))
const _0775611c = () => interopDefault(import('../pages/gaia/report-center/_reportId/index.vue' /* webpackChunkName: "pages/gaia/report-center/_reportId/index" */))
const _286a9774 = () => interopDefault(import('../pages/gaia/course/_courseId/script.js' /* webpackChunkName: "pages/gaia/course/_courseId/script" */))
const _3b5d5e54 = () => interopDefault(import('../pages/gaia/report-center/_reportId/script.js' /* webpackChunkName: "pages/gaia/report-center/_reportId/script" */))
const _1f9f3544 = () => interopDefault(import('../pages/gaia/course/_courseId/content/script.js' /* webpackChunkName: "pages/gaia/course/_courseId/content/script" */))
const _1a81c7e4 = () => interopDefault(import('../pages/gaia/course/_courseId/content/_id.vue' /* webpackChunkName: "pages/gaia/course/_courseId/content/_id" */))
const _9b40a94a = () => interopDefault(import('../pages/core/wc/_wcApplicationRouteBase/_wcTag.vue' /* webpackChunkName: "pages/core/wc/_wcApplicationRouteBase/_wcTag" */))

const emptyFn = () => {}

Vue.use(Router)

export const routerOptions = {
  mode: 'history',
  base: '/plataforma/',
  linkActiveClass: 'nuxt-link-active',
  linkExactActiveClass: 'nuxt-link-exact-active',
  scrollBehavior,

  routes: [{
    path: "/editing",
    component: _7c14f56c,
    name: "editing"
  }, {
    path: "/script",
    component: _93cf9df6,
    name: "script"
  }, {
    path: "/view",
    component: _402bc367,
    name: "view"
  }, {
    path: "/callback",
    component: _6efa74ee,
    name: "core-callback"
  }, {
    path: "/error",
    component: _4a93814c,
    name: "core-error"
  }, {
    path: "/my-account",
    component: _bd409d60,
    name: "core-my-account"
  }, {
    path: "/role-not-found",
    component: _05254216,
    name: "core-role-not-found"
  }, {
    path: "/welcome",
    component: _17d52318,
    name: "core-welcome"
  }, {
    path: "/editing/script",
    component: _89a5f764,
    name: "editing-script"
  }, {
    path: "/achievements",
    component: _57429bf5,
    name: "gaia-achievements"
  }, {
    path: "/calendar",
    component: _75dd328f,
    name: "gaia-calendar"
  }, {
    path: "/dashboards",
    component: _094cd4f0,
    name: "gaia-dashboards"
  }, {
    path: "/grade-template",
    component: _d711bbfe,
    name: "gaia-grade-template"
  }, {
    path: "/lti-launch",
    component: _aec610a0,
    name: "gaia-lti-launch"
  }, {
    path: "/lti-resolve",
    component: _8d2554b6,
    name: "gaia-lti-resolve"
  }, {
    path: "/lti-tools",
    component: _f2dbe358,
    name: "gaia-lti-tools"
  }, {
    path: "/my-achievements",
    component: _996737ec,
    name: "gaia-my-achievements"
  }, {
    path: "/new-calendar",
    component: _517448dc,
    name: "gaia-new-calendar"
  }, {
    path: "/page-messages",
    component: _eb3d3d22,
    name: "gaia-page-messages"
  }, {
    path: "/question",
    component: _4e05c137,
    name: "gaia-question"
  }, {
    path: "/report-center",
    component: _4590ae9a,
    name: "gaia-report-center"
  }, {
    path: "/view/script",
    component: _7f43d249,
    name: "view-script"
  }, {
    path: "/auth/forgot-username",
    component: _0eb69ec6,
    name: "core-auth-forgot-username"
  }, {
    path: "/auth/signin",
    component: _60de6e8a,
    name: "core-auth-signin"
  }, {
    path: "/auth/signup",
    component: _55adeeb1,
    name: "core-auth-signup"
  }, {
    path: "/error/script",
    component: _19ce4e3c,
    name: "core-error-script"
  }, {
    path: "/my-account/script",
    component: _3f107f9c,
    name: "core-my-account-script"
  }, {
    path: "/role-not-found/script",
    component: _3c856dd7,
    name: "core-role-not-found-script"
  }, {
    path: "/welcome/script",
    component: _332d7d56,
    name: "core-welcome-script"
  }, {
    path: "/achievements/script",
    component: _d34aaa52,
    name: "gaia-achievements-script"
  }, {
    path: "/batch-edit",
    component: _6f057be4,
    name: "gaia-admin-batch-edit"
  }, {
    path: "/batch-edit-logs",
    component: _cee25f38,
    name: "gaia-admin-batch-edit-logs"
  }, {
    path: "/categories",
    component: _079970ad,
    name: "gaia-admin-categories"
  }, {
    path: "/config-homepage",
    component: _104a993e,
    name: "gaia-admin-config-homepage"
  }, {
    path: "/content-management",
    component: _bcaf9e30,
    name: "gaia-admin-content-management"
  }, {
    path: "/functions",
    component: _3cfae880,
    name: "gaia-admin-functions"
  }, {
    path: "/lti-providers",
    component: _294a031b,
    name: "gaia-admin-lti-providers"
  }, {
    path: "/notices",
    component: _4a84b340,
    name: "gaia-admin-notices"
  }, {
    path: "/periods",
    component: _e23cce92,
    name: "gaia-admin-periods"
  }, {
    path: "/rubrics",
    component: _04b64e6a,
    name: "gaia-admin-rubrics"
  }, {
    path: "/terms",
    component: _23b24bac,
    name: "gaia-admin-terms"
  }, {
    path: "/users",
    component: _3d00ba26,
    name: "gaia-admin-users"
  }, {
    path: "/calendar/script",
    component: _96157d1e,
    name: "gaia-calendar-script"
  }, {
    path: "/content/script",
    component: _31355a80,
    name: "gaia-content-script"
  }, {
    path: "/dashboards/script",
    component: _4864e3d2,
    name: "gaia-dashboards-script"
  }, {
    path: "/grade-template/script",
    component: _58e19e3a,
    name: "gaia-grade-template-script"
  }, {
    path: "/lti-launch/script",
    component: _3095f2dc,
    name: "gaia-lti-launch-script"
  }, {
    path: "/lti-resolve/script",
    component: _0ef536f2,
    name: "gaia-lti-resolve-script"
  }, {
    path: "/lti-tools/script",
    component: _74abc594,
    name: "gaia-lti-tools-script"
  }, {
    path: "/my-achievements/script",
    component: _1b371a28,
    name: "gaia-my-achievements-script"
  }, {
    path: "/new-calendar/script",
    component: _dee75084,
    name: "gaia-new-calendar-script"
  }, {
    path: "/page-messages/script",
    component: _6d0d1f5e,
    name: "gaia-page-messages-script"
  }, {
    path: "/plataforma-error/script",
    component: _225b6439,
    name: "gaia-plataforma-error-script"
  }, {
    path: "/question/script",
    component: _e5c45fce,
    name: "gaia-question-script"
  }, {
    path: "/report-center/script",
    component: _1c4fb795,
    name: "gaia-report-center-script"
  }, {
    path: "/my-notices",
    component: _375f0d9f,
    name: "gaia-student-my-notices"
  }, {
    path: "/auth/forgot-username/script",
    component: _37bcbf7f,
    name: "core-auth-forgot-username-script"
  }, {
    path: "/auth/password/change",
    component: _13af2dfe,
    name: "core-auth-password-change"
  }, {
    path: "/auth/password/expired",
    component: _136ebeec,
    name: "core-auth-password-expired"
  }, {
    path: "/auth/password/new",
    component: _3eda4b76,
    name: "core-auth-password-new"
  }, {
    path: "/auth/password/reset",
    component: _63fb84b4,
    name: "core-auth-password-reset"
  }, {
    path: "/auth/signin/script",
    component: _0ea8d79d,
    name: "core-auth-signin-script"
  }, {
    path: "/auth/signup/script",
    component: _d67404da,
    name: "core-auth-signup-script"
  }, {
    path: "/academic/script",
    component: _a9109b8c,
    name: "gaia-admin-academic-script"
  }, {
    path: "/batch-edit-logs/script",
    component: _50b24174,
    name: "gaia-admin-batch-edit-logs-script"
  }, {
    path: "/batch-edit/script",
    component: _079550f0,
    name: "gaia-admin-batch-edit-script"
  }, {
    path: "/categories/script",
    component: _46b17f8f,
    name: "gaia-admin-categories-script"
  }, {
    path: "/config-homepage/script",
    component: _4f62a820,
    name: "gaia-admin-config-homepage-script"
  }, {
    path: "/content-management/script",
    component: _3e7f806c,
    name: "gaia-admin-content-management-script"
  }, {
    path: "/functions/script",
    component: _209a9aa2,
    name: "gaia-admin-functions-script"
  }, {
    path: "/lti-providers/script",
    component: _686211fd,
    name: "gaia-admin-lti-providers-script"
  }, {
    path: "/notices/script",
    component: _ecc67bbc,
    name: "gaia-admin-notices-script"
  }, {
    path: "/periods/script",
    component: _640cb0ce,
    name: "gaia-admin-periods-script"
  }, {
    path: "/rubrics/script",
    component: _3cbce7ad,
    name: "gaia-admin-rubrics-script"
  }, {
    path: "/terms/script",
    component: _62ca5a8e,
    name: "gaia-admin-terms-script"
  }, {
    path: "/users/script",
    component: _2097b1cf,
    name: "gaia-admin-users-script"
  }, {
    path: "/my-grades/script",
    component: _ae3d74a0,
    name: "gaia-student-my-grades-script"
  }, {
    path: "/my-notices/script",
    component: _76771c81,
    name: "gaia-student-my-notices-script"
  }, {
    path: "/grades/script",
    component: _281e223c,
    name: "gaia-teacher-grades-script"
  }, {
    path: "/messages/script",
    component: _06a2ff4c,
    name: "gaia-teacher-messages-script"
  }, {
    path: "/auth/password/change/script",
    component: _354077e3,
    name: "core-auth-password-change-script"
  }, {
    path: "/auth/password/expired/script",
    component: _3560af6c,
    name: "core-auth-password-expired-script"
  }, {
    path: "/auth/password/reset/script",
    component: _b9d8d8d4,
    name: "core-auth-password-reset-script"
  }, {
    path: "/auth/social/google/script",
    component: _2b95f51a,
    name: "core-auth-social-google-script"
  }, {
    path: "/auth/social/linkedin/script",
    component: _9cca86c2,
    name: "core-auth-social-linkedin-script"
  }, {
    path: "/",
    component: _77002223,
    name: "index"
  }, {
    path: "/users/edit/:id?",
    component: _7392c4ea,
    name: "gaia-admin-users-edit-id"
  }, {
    path: "/academic/:type?",
    component: _7996c71f,
    name: "gaia-admin-academic-type"
  }, {
    path: "/functions/:id",
    component: _78afc6ab,
    name: "gaia-admin-functions-id"
  }, {
    path: "/my-enrollments/:type",
    component: _b1b0ef86,
    name: "gaia-student-my-enrollments-type"
  }, {
    path: "/my-grades/:courseId?",
    component: _1dff7271,
    name: "gaia-student-my-grades-courseId"
  }, {
    path: "/grades/:courseId?",
    component: _79b9ae06,
    name: "gaia-teacher-grades-courseId"
  }, {
    path: "/messages/:id?",
    component: _230e0552,
    name: "gaia-teacher-messages-id"
  }, {
    path: "/my/:id",
    component: _46f0c8f5,
    name: "gaia-teacher-my-id"
  }, {
    path: "/functions/:id/script",
    component: _907054e6,
    name: "gaia-admin-functions-id-script"
  }, {
    path: "/my-enrollments/:type?/script",
    component: _3380d1c2,
    name: "gaia-student-my-enrollments-type-script"
  }, {
    path: "/my/:id?/script",
    component: _f3ee5052,
    name: "gaia-teacher-my-id-script"
  }, {
    path: "/my-enrollments/:type?/:id",
    component: _9b4f86b0,
    name: "gaia-student-my-enrollments-type-id"
  }, {
    path: "/my-enrollments/:type?/:id?/script",
    component: _1d1f68ec,
    name: "gaia-student-my-enrollments-type-id-script"
  }, {
    path: "/content/:id?",
    component: _7b76a5c6,
    name: "gaia-content-id"
  }, {
    path: "/course/:courseId",
    component: _2d5aeedc,
    name: "gaia-course-courseId"
  }, {
    path: "/plataforma-error/:id?",
    component: _0184c17f,
    name: "gaia-plataforma-error-id"
  }, {
    path: "/report-center/:reportId",
    component: _0775611c,
    name: "gaia-report-center-reportId"
  }, {
    path: "/course/:courseId?/script",
    component: _286a9774,
    name: "gaia-course-courseId-script"
  }, {
    path: "/report-center/:reportId?/script",
    component: _3b5d5e54,
    name: "gaia-report-center-reportId-script"
  }, {
    path: "/course/:courseId?/content/script",
    component: _1f9f3544,
    name: "gaia-course-courseId-content-script"
  }, {
    path: "/course/:courseId?/content/:id?",
    component: _1a81c7e4,
    name: "gaia-course-courseId-content-id"
  }, {
    path: "/wc/:wcApplicationRouteBase?/:wcTag?",
    component: _9b40a94a,
    name: "core-wc-wcApplicationRouteBase-wcTag"
  }],

  fallback: false
}

export function createRouter (ssrContext, config) {
  const base = (config._app && config._app.basePath) || routerOptions.base
  const router = new Router({ ...routerOptions, base  })

  // TODO: remove in Nuxt 3
  const originalPush = router.push
  router.push = function push (location, onComplete = emptyFn, onAbort) {
    return originalPush.call(this, location, onComplete, onAbort)
  }

  const resolve = router.resolve.bind(router)
  router.resolve = (to, current, append) => {
    if (typeof to === 'string') {
      to = normalizeURL(to)
    }
    return resolve(to, current, append)
  }

  return router
}
